import React from 'react';
import { Link } from 'react-router-dom';
import '../navbar/navbar.css'


export default function navbar(props) {
    return (<>

{/* horizontal navbar  social media*/}
        <nav className="navbar fixed-top">
            <Link className="Header-name" to="/" style={{textDecoration:"none", color: "#12192C"}}
            ><h>{props.navbarname}</h></Link>
            <div className="main mx-5">
                <div className="clickable navbar-collapse" id="navbarSupportedContent">
                    <ul className="ul navbar-nav ms-auto align-items-center">
                        <li className="nav-item"> 
                            <Link className="elements" to="/"><i className="element"></i>{props.navElement1}</Link>
                        </li>
                        <li className="nav-item">

                            <Link className="elements" to="/Project"><i className="element"></i>{props.navElement2}</Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link className="elements" to="/Home"><i className="element"></i>{props.navElement3}</Link>
                        </li> */}
                        {/* <li className="nav-item">
                            <a className="elements" href="#!"><i className="element"></i>{props.navElement4}</a>
                        </li> */}

                    </ul>
                </div>
            </div>
        </nav>









        {/* vertical navbar  name and links*/}
        <div className="l-navbar" id="navbar">
            <nav className="nav">

                <div className="nav__list">
                    <a href="https://www.facebook.com/avanish.pamdey" className="nav__link active" target="_blank" rel='noreferrer'>
                        <ion-icon name="logo-facebook"></ion-icon>
                        {/* <span className="nav__name"></span> */}
                    </a>
                    <a href="https://www.linkedin.com/in/avanish-chandra-pandey-43468a19a/" className="nav__link" target="_blank" rel='noreferrer'>
                        <ion-icon name="logo-linkedin"></ion-icon>
                        {/* <span className="nav__name"></span> */}
                    </a>

                    <a href="https://www.instagram.com/iama_c_p/" className="nav__link" target="_blank" rel='noreferrer'>
                        <ion-icon name="logo-instagram"></ion-icon>
                        {/* <span className="nav__name"></span> */}
                    </a> 

                    <a href="mailto:avanishpandey022@gmail.com" className="nav__link">
                        <ion-icon name="mail-outline"></ion-icon>
                    </a>
                </div>

            </nav>
        </div>
    </>
    )
}



